import { onSharedFolderFetchFailed } from '../actions/onSharedFolderFetchFailed';
import loc from 'owa-localize';
import { cantCompleteRequestText } from 'owa-locstrings/lib/strings/cantcompleterequesttext.locstring.json';
import { notEnoughPermissionText } from 'owa-locstrings/lib/strings/notenoughpermissiontext.locstring.json';
import { showErrorMessage } from 'owa-mail-folder-store';
import toggleFolderNodeExpansion from 'owa-mail-folder-store/lib/actions/toggleFolderNodeExpansion';
import { orchestrator } from 'satcheljs';

/**
 * This orchestrator is responsible for showing the error dialog when getting subfolder call fails.
 * It also sets the folder to closed state if the action source of it is folderPane
 */
orchestrator(onSharedFolderFetchFailed, actionMessage => {
    showErrorMessage(loc(cantCompleteRequestText), loc(notEnoughPermissionText));
    if (actionMessage.actionSource === 'folderPane') {
        toggleFolderNodeExpansion(
            actionMessage.principalSMTPAddress,
            false /* doNotPersistUserConfig */
        );
    }
});
